import { render } from "./SejourMedicalDetailsView.vue?vue&type=template&id=696da6a9"
import script from "./SejourMedicalDetailsView.vue?vue&type=script&lang=js"
export * from "./SejourMedicalDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__